import Big from 'big.js';
import { Decimals } from '@block-explorer/entities';
import {
  DEFAULT_AMOUNT_PRECISION,
  formatBigNumbers,
  formatNumber,
} from '@make-software/cspr-design';

export const tokenDivider = (decimals: Decimals) =>
  Big(10).pow(Number(decimals || 0));

export const getAmountFromMotes = (
  amount: string | undefined | null,
  decimals: Decimals
) => {
  // in case of invalid amount from parsed arguments
  if (Number.isNaN(Number(amount))) {
    return 'N/A';
  }

  return Big(amount?.toString() || 0)
    .div(tokenDivider(Number(decimals || 0)))
    .toString();
};

export const formatTokenAmount = (
  amount: string | undefined | null,
  precision?: number,
  shouldShortenAmount?: boolean
) => {
  if (amount === 'N/A') {
    return amount;
  }

  const amountPrecision = precision ?? DEFAULT_AMOUNT_PRECISION;

  const displayThresholdValue = Big(1).div(Big(10).pow(amountPrecision));
  const isAmountBelowDisplayThreshold =
    amount && Big(amount).gt(0) && Big(amount).lt(displayThresholdValue);

  if (isAmountBelowDisplayThreshold) {
    return `< ${formatNumber(displayThresholdValue.toString(), { precision: amountPrecision })}`;
  }

  const formattedCep18Amount = amount
    ? formatNumber(amount, {
        precision: amountPrecision,
      })
    : '-';

  const isAmountBiggerThanThousand = amount
    ? Big(amount).gte(1000) && formattedCep18Amount.length > 7
    : false;

  if (isAmountBiggerThanThousand && shouldShortenAmount) {
    return formatBigNumbers(amount);
  }

  return formattedCep18Amount;
};

export const ftTokenAmountToCurrency = (
  amount: string | number,
  currencyPerFtTokenRate: number
): string => {
  if (currencyPerFtTokenRate === 0) {
    throw new Error('ftTokenAmountToCurrency: the price cannot be zero');
  }

  return Big(amount.toString())
    .mul(currencyPerFtTokenRate.toString())
    .toString();
};
